import React from "react";
import { useNavigate } from "react-router-dom";
import pasteListIcon from "../assets/pastelist.svg";
import compareIcon from "../assets/compare.svg";
import topDealsIcon from "../assets/topdeals.svg";
import myListIcon from "../assets/myList.svg";

const actions = [
  {
    id: "lists",
    label: "My Grocery List",
    iconSrc: myListIcon,
    path: "/settings",
    search: "?tab=grocery",
  },
  {
    id: "compare",
    label: "Compare Prices",
    iconSrc: compareIcon,
    path: "/features",
  },
  {
    id: "deals",
    label: "Top Deals",
    iconSrc: topDealsIcon,
    path: "/top-deals",
  },
  {
    id: "paste",
    label: "Paste List",
    iconSrc: pasteListIcon,
    path: "/",
    focusSearch: true,
  },
];

export default function HomeQuickActionsBar({ onPasteList }) {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <div className="grid grid-cols-4 gap-2 md:gap-8">
        {actions.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => {
              if (item.id === "paste" && typeof onPasteList === "function") {
                onPasteList();
                return;
              }
              navigate(`${item.path}${item.search || ""}`);
              if (item.focusSearch) {
                requestAnimationFrame(() => {
                  const el = document.querySelector('input[placeholder*="Paste"]');
                  el?.focus?.();
                });
              }
            }}
            className="flex min-h-[56px] w-full flex-col items-center justify-center gap-2 rounded-xl border border-[#E6EAF0] bg-white px-3 py-2.5 text-center shadow-sm sm:min-h-[60px] sm:flex-row sm:justify-start sm:gap-3 sm:px-4 sm:py-2.5 sm:text-left"
          >
            <img
              src={item.iconSrc}
              alt=""
              width={48}
              height={48}
              className="h-10 w-10 shrink-0 object-contain sm:h-12 sm:w-12"
              aria-hidden
            />
            <span className="text-[16px] font-bold leading-tight text-[#24303A] sm:text-[18px]">
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
